import { createContext } from 'react';

type JobSubscriptionContextType = {
    addJobId: (id: string) => void;
    finishedJobIds: Set<string>;
    clearFinishedJob: (id: string) => void;
};

const JobSubscriptionContext = createContext<JobSubscriptionContextType | null>(null);

export default JobSubscriptionContext;
